module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "forum-thread-list",
    class: {
      'no-header': !_vm.header
    }
  }, [(_vm.header) ? _c('thead', [_c('th', {
    staticClass: "threads-col"
  }, [_vm._v("\n            Thread\n        ")]), _vm._v(" "), (_vm.sortable) ? _c('th', {
    staticClass: "replies-col btn-wrapper"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.onRepliesHeaderClick()
      }
    }
  }, [_vm._v("\n                Replies\n                "), (_vm.sortable && _vm.sortOrder === 'postCount:asc') ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.sortable && _vm.sortOrder === 'postCount:desc') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "replies-col"
  }, [_vm._v("\n            Replies\n        ")]), _vm._v(" "), (_vm.sortable) ? _c('th', {
    staticClass: "views-col btn-wrapper"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.onViewsHeaderClick()
      }
    }
  }, [_vm._v("\n                Views\n                "), (_vm.sortable && _vm.sortOrder === 'viewCount:asc') ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.sortable && _vm.sortOrder === 'viewCount:desc') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "views-col"
  }, [_vm._v("\n            Views\n        ")]), _vm._v(" "), (_vm.sortable) ? _c('th', {
    staticClass: "activity-col btn-wrapper"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.onActivityHeaderClick()
      }
    }
  }, [_vm._v("\n                Activity\n                "), (_vm.sortable && _vm.sortOrder === 'lastPostCreatedAt:asc') ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.sortable && _vm.sortOrder === 'lastPostCreatedAt:desc') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "activity-col"
  }, [_vm._v("\n            Activity\n        ")])]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.threads), function(thread) {
    return _c('tr', {
      key: thread.id
    }, [_c('td', {
      staticClass: "threads-col"
    }, [_c('div', {
      staticClass: "thread-title"
    }, [(thread.sticky) ? _c('i', {
      staticClass: "fa fa-thumb-tack",
      attrs: {
        "title": "Sticky"
      }
    }) : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": _vm.getThreadUrl(thread)
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.formatTitle(thread)) + "\n                    ")])], 1), _vm._v(" "), _vm._t("extra", [_c('div', {
      staticClass: "thread-category"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.getCategoryUrl(thread)
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.formatCategory(thread)) + "\n                        ")])], 1)], {
      thread: thread
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "replies-col",
      attrs: {
        "title": _vm.getRepliesTooltip(thread)
      }
    }, [_vm._v("\n                " + _vm._s(_vm.formatReplies(thread)) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "views-col",
      attrs: {
        "title": _vm.getViewsTooltip(thread)
      }
    }, [_vm._v("\n                " + _vm._s(_vm.formatViews(thread)) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "activity-col",
      attrs: {
        "title": _vm.getActivityTooltip(thread)
      }
    }, [_vm._v("\n                " + _vm._s(_vm.formatActivity(thread)) + "\n            ")])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ce48779!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/thread-list.vue
// module id = 2056
// module chunks = 2